import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  rmnConsumerVoiceReportEndpoint,
  rmnConsumerVoiceReportsEndpoint,
} from '../../api/endpoints'
import { MainContainer } from '../../components/ContentWrapper'
import { ListPageHeader } from '../../components/ListPageHeader/ListPageHeader'
import { ConsumerVoiceHistorySection } from '../../components/ConsumerVoice/ConsumerVoiceHistorySection'
import { useNetworkScope } from '../../hooks/useNetworkScope'
import { ConsumerVoiceAudit } from '../../types/consumerVoice'

// Intelligence > Consumer Voice History: the client's Consumer Voice runs
// (brand runs + standalone product runs) with view / PDF / Create strategy.
// Runs start from the Catalog pages; this is the history for every brand
// plan. Same list the Catalog > Brands page shows under its table, mounted
// on its own page so single brands (no Brands page) can reach it too.
export default function RmnConsumerVoiceHistoryPage() {
  const navigate = useNavigate()
  const { basePath, isNetwork } = useNetworkScope()

  // Same hand-off as Catalog > Brands: the strategy wizard reads ?cv=<id>.
  const createStrategy = (audit: ConsumerVoiceAudit) => {
    const params = new URLSearchParams({ cv: String(audit.id) })
    if (audit.desireid) params.set('desireid', String(audit.desireid))
    navigate(`${basePath}/opportunities/strategies/new?${params.toString()}`)
  }

  return (
    <MainContainer>
      <ListPageHeader
        title="Consumer Voice History"
        subtitle="Past Consumer Voice analyses, newest first"
      />
      <ConsumerVoiceHistorySection
        listEndpoint={rmnConsumerVoiceReportsEndpoint}
        itemEndpoint={rmnConsumerVoiceReportEndpoint}
        title="Consumer Voice Reports"
        onCreateStrategy={createStrategy}
        emptyMessage={isNetwork
          ? 'No Consumer Voice analyses yet — run one from a brand or product row.'
          : 'No Consumer Voice analyses yet — run one from a product row.'}
      />
    </MainContainer>
  )
}
